import { FontAwesome } from "@expo/vector-icons";
import { EventNoticeDetails } from "features/types";
import React from "react";

interface EventNoticeIconProps {
  type: EventNoticeDetails["type"];
  size: number;
}

export const eventNoticeConfig = {
  icon: {
    HEALTH: "plus",
    INFO: "info",
    PROMO: "star",
    PREMIUM: "usd",
  },
  color: {
    HEALTH: "#9b2c2c",
    INFO: "#1e40af",
    PROMO: "#9c4221",
    PREMIUM: "#975a16",
  },
  backgroundColor: {
    HEALTH: "#fee2e2",
    INFO: "#dbeafe",
    PROMO: "#ffedd5",
    PREMIUM: "#fef9c3",
  },
  border: {
    HEALTH: "#fca5a5",
    INFO: "#93c5fd",
    PROMO: "#fdba74",
    PREMIUM: "#fde047",
  },
};
const EventNoticeIcon: React.FC<EventNoticeIconProps> = ({ type, size }) => {
  const iconName = eventNoticeConfig.icon[
    type
  ] as keyof typeof FontAwesome.glyphMap;
  const iconColor = eventNoticeConfig.color[type];
  return (
    <FontAwesome name={iconName} color={iconColor} size={size}></FontAwesome>
  );
};

export default EventNoticeIcon;
